import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Axios from "axios";
import { useDispatch } from "react-redux";
import {
  Row,
  Col,
  Button,
  Modal,
  Form,
  Card,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";

//ACTIONS
import * as GS_navSettingsActions from "../../../../../store/actions/globalSettings/GS_navSettings";

//STYLES
import * as PlanDetailsStyles from "../styles/planDetails";

function PlanDetails() {
  const params = useParams();
  const [plan, setPlan] = useState({});

  const [admins, setAdmins] = useState([]);
  const [users, setUsers] = useState([]);
  const [contractors, setContractors] = useState([]);

  const dispatch = useDispatch();

  const [newUserModal, setNewUserModal] = useState({
    open: false,
    type: "",
    values: {
      name: "",
      email: "",
    },
    valids: {
      name: false,
      email: false,
    },
    touched: {
      name: false,
      email: false,
    },
    wholeForm: false,
  });

  function handleCloseNewUserModal() {
    setNewUserModal((prevState) => {
      return { ...prevState, open: false };
    });
  }

  const [modal, setModal] = useState({
    open: false,
    header: "",
    message: "",
  });

  function handleModalClose() {
    setModal((prevState) => {
      return { ...prevState, open: false };
    });
  }

  const [modalYN, setModalYN] = useState({
    open: false,
    heading: "",
    message: "",
    acceptFunction: "",
    acceptName: "",
    showAccept: false,
    cancelName: "",
    showCancel: false,
  });

  function handleModalYNClose() {
    setModalYN((prevState) => {
      return { ...prevState, open: false };
    });
  }

  useEffect(() => {
    dispatch(GS_navSettingsActions.UpdateTitle("Planner"));
    dispatch(GS_navSettingsActions.UpdateSelected("Features"));
    dispatch(GS_navSettingsActions.UpdateSubSelected("Planner"));

    loadPlan();
  }, []);

  function loadPlan() {
    const data = { uuid: params.id };

    Axios.post("/pods/plannerAdmin/getPlan", data)
      .then((res) => {
        const data = res.data;
        console.log(data);
        if (data.error == "null") {
          setPlan(data.plan);
          setAdmins(data.users.filter((user) => user.type == "admin"));
          setContractors(
            data.users.filter((user) => user.type == "contractor")
          );
          setUsers(data.users.filter((user) => user.type == "user"));
        }
      })
      .catch((err) => console.log(err));
  }

  function handleOpenNewUserModal(type) {
    setNewUserModal((prevState) => {
      return {
        ...prevState,
        open: true,
        type: type,
        values: {
          name: "",
          email: "",
        },
        valids: {
          name: false,
          email: false,
        },
        touched: {
          name: false,
          email: false,
        },
        wholeForm: false,
      };
    });
  }

  function handleOnTouch(event) {
    const { name } = event.target;

    const touches = newUserModal.touched;
    touches[name] = true;

    setNewUserModal((prevState) => {
      return { ...prevState, touched: touches };
    });
  }

  function handleTextInput(event) {
    const { name, value } = event.target;

    const values = newUserModal.values;
    const valids = newUserModal.valids;

    let isValid = true;
    if (value.length == 0) {
      isValid = false;
    }

    if (
      name === "email" &&
      !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/gm.test(value)
    ) {
      isValid = false;
    }

    values[name] = value;
    valids[name] = isValid;

    const wholeForm = Object.values(valids).every((value) => value == true);

    setNewUserModal((prevState) => {
      return {
        ...prevState,
        values: values,
        valids: valids,
        wholeForm: wholeForm,
      };
    });
  }

  function switchAllTouches() {
    const newTouches = Object.assign(
      ...Object.keys(newUserModal.touched).map((k) => ({ [k]: true }))
    );
    setNewUserModal((prevState) => {
      return { ...prevState, touched: newTouches };
    });
  }

  function handleSubmitAdd() {
    if (!newUserModal.wholeForm) {
      switchAllTouches();
    } else {
      const data = {
        planUUID: params.id,
        name: newUserModal.values.name,
        email: newUserModal.values.email,
        type: newUserModal.type,
      };
      Axios.post("/pods/plannerAdmin/addUserToPlan", data)
        .then((res) => {
          const data = res.data;
          if (data.error == "Yes") {
            setModal({
              header: "Add New User",
              message: data.message,
              open: true,
            });
          } else {
            setModal({
              header: "Add New User",
              message: data.message,
              open: true,
            });
            setNewUserModal((prevState) => {
              return { ...prevState, open: false };
            });
            loadPlan();
          }
        })
        .catch((err) => console.log(err));
    }
  }

  function handleRemoveUser(uuid) {
    setModalYN({
      heading: "Remove user from plan",
      message: "Are you sure you want to remove this user from this plan?",
      showAccept: true,
      acceptName: "Yes",
      acceptFunction: acceptRemove.bind(this, uuid),
      showCancel: true,
      cancelName: "No",
      open: true,
    });
  }

  function acceptRemove(uuid) {
    const data = { uuid: uuid };
    Axios.post("/pods/plannerAdmin/removeUser", data)
      .then((res) => {
        const data = res.data;
        if (data.error == "null") {
          loadPlan();
          setModalYN((prevState) => {
            return { ...prevState, open: false };
          });
        }
      })
      .catch((err) => console.log(err));
  }

  return (
    <div>
      <Row>
        <Col style={PlanDetailsStyles.planTitle}>
          <h3>
            <strong>{plan != null && plan.title}</strong>
          </h3>
        </Col>
      </Row>
      <div style={PlanDetailsStyles.body}>
        <Row>
          <Col style={PlanDetailsStyles.sectionHeading}>
            <strong>Admins</strong>
          </Col>
          <Col style={PlanDetailsStyles.sectionHeadingBtn}>
            <Button onClick={handleOpenNewUserModal.bind(this, "admin")}>
              <i className="fa-solid fa-plus"></i>
            </Button>
          </Col>
        </Row>
        <Row>
          <Col style={PlanDetailsStyles.usersSection}>
            {admins.length > 0 ? (
              <div>
                {admins.map((user, index) => {
                  return (
                    <div key={index}>
                      <Card style={PlanDetailsStyles.userCard}>
                        <Card.Body>
                          <Row>
                            <Col>
                              Name: <br /> {user.details.fullName}
                            </Col>
                            <Col>
                              Email: <br /> {user.details.email}
                            </Col>
                            <Col style={PlanDetailsStyles.deleteBtnSection}>
                              {user.details.email !=
                                "plannermaster@high-view-studios.co.uk" && (
                                <div>
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Remove User</Tooltip>}
                                  >
                                    <Button
                                      variant="danger"
                                      onClick={handleRemoveUser.bind(
                                        this,
                                        user.uuid
                                      )}
                                    >
                                      <i className="fa-solid fa-trash-can"></i>
                                    </Button>
                                  </OverlayTrigger>
                                </div>
                              )}
                            </Col>
                          </Row>
                        </Card.Body>
                      </Card>
                      <br />
                    </div>
                  );
                })}
              </div>
            ) : (
              "No Users"
            )}
          </Col>
        </Row>
        <Row>
          <Col style={PlanDetailsStyles.sectionHeading}>
            <strong>Contractors</strong>
          </Col>
          <Col style={PlanDetailsStyles.sectionHeadingBtn}>
            <Button onClick={handleOpenNewUserModal.bind(this, "contractor")}>
              <i className="fa-solid fa-plus"></i>
            </Button>
          </Col>
        </Row>
        <Row>
          <Col style={PlanDetailsStyles.usersSection}>
            {contractors.length > 0 ? (
              <div>
                {contractors.map((user, index) => {
                  return (
                    <div key={index}>
                      <Card style={PlanDetailsStyles.userCard}>
                        <Card.Body>
                          <Row>
                            <Col>
                              Name: <br /> {user.details.fullName}
                            </Col>
                            <Col>
                              Email: <br /> {user.details.email}
                            </Col>
                            <Col style={PlanDetailsStyles.deleteBtnSection}>
                              {user.details.email !=
                                "plannermaster@high-view-studios.co.uk" && (
                                <div>
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Remove User</Tooltip>}
                                  >
                                    <Button
                                      variant="danger"
                                      onClick={handleRemoveUser.bind(
                                        this,
                                        user.uuid
                                      )}
                                    >
                                      <i className="fa-solid fa-trash-can"></i>
                                    </Button>
                                  </OverlayTrigger>
                                </div>
                              )}
                            </Col>
                          </Row>
                        </Card.Body>
                      </Card>
                      <br />
                    </div>
                  );
                })}
              </div>
            ) : (
              "No Users"
            )}
          </Col>
        </Row>
        <Row>
          <Col style={PlanDetailsStyles.sectionHeading}>
            <strong>Users</strong>
          </Col>
          <Col style={PlanDetailsStyles.sectionHeadingBtn}>
            <Button onClick={handleOpenNewUserModal.bind(this, "user")}>
              <i className="fa-solid fa-plus"></i>
            </Button>
          </Col>
        </Row>
        <Row>
          <Col style={PlanDetailsStyles.usersSection}>
            {users.length > 0 ? (
              <div>
                {users.map((user, index) => {
                  return (
                    <div key={index}>
                      <Card style={PlanDetailsStyles.userCard}>
                        <Card.Body>
                          <Row>
                            <Col>
                              Name: <br /> {user.details.fullName}
                            </Col>
                            <Col>
                              Email: <br /> {user.details.email}
                            </Col>
                            <Col style={PlanDetailsStyles.deleteBtnSection}>
                              {user.details.email !=
                                "plannermaster@high-view-studios.co.uk" && (
                                <div>
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Remove User</Tooltip>}
                                  >
                                    <Button
                                      variant="danger"
                                      onClick={handleRemoveUser.bind(
                                        this,
                                        user.uuid
                                      )}
                                    >
                                      <i className="fa-solid fa-trash-can"></i>
                                    </Button>
                                  </OverlayTrigger>
                                </div>
                              )}
                            </Col>
                          </Row>
                        </Card.Body>
                      </Card>
                      <br />
                    </div>
                  );
                })}
              </div>
            ) : (
              "No Users"
            )}
          </Col>
        </Row>
      </div>
      <Modal></Modal>
      <Modal show={newUserModal.open} onHide={handleCloseNewUserModal}>
        <Modal.Header closeButton>
          <Modal.Title>Add New User</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Name:</Form.Label>
            <Form.Control
              isInvalid={
                newUserModal.touched.name && !newUserModal.valids.name
                  ? true
                  : false
              }
              type="text"
              name="name"
              value={newUserModal.values.name}
              onChange={handleTextInput}
              onBlur={handleOnTouch}
            />
            <Form.Control.Feedback type="invalid">
              Please enter a name!
            </Form.Control.Feedback>
          </Form.Group>
          <br />
          <Form.Group>
            <Form.Label>Email:</Form.Label>
            <Form.Control
              isInvalid={
                newUserModal.touched.email && !newUserModal.valids.email
                  ? true
                  : false
              }
              type="text"
              name="email"
              value={newUserModal.values.email}
              onChange={handleTextInput}
              onBlur={handleOnTouch}
            />
            <Form.Control.Feedback type="invalid">
              Please enter a valid email
            </Form.Control.Feedback>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleSubmitAdd}>Add</Button>
          <Button onClick={handleCloseNewUserModal}>Close</Button>
        </Modal.Footer>
      </Modal>
      <Modal show={modal.open} onHide={handleModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>{modal.header}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{modal.message}</Modal.Body>
        <Modal.Footer>
          <Button onClick={handleModalClose}>Close</Button>
        </Modal.Footer>
      </Modal>
      <Modal show={modalYN.open} onHide={handleModalYNClose}>
        <Modal.Header closeButton>
          <Modal.Title>{modalYN.heading}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{modalYN.message}</Modal.Body>
        <Modal.Footer>
          {modalYN.showAccept ? (
            <div>
              <Button variant="primary" onClick={modalYN.acceptFunction}>
                {modalYN.acceptName}
              </Button>
            </div>
          ) : null}
          {modalYN.showCancel ? (
            <div>
              <Button variant="primary" onClick={handleModalYNClose}>
                {modalYN.cancelName}
              </Button>
            </div>
          ) : null}
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default PlanDetails;
